import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqs = [
  {
    q: "How is this different from Sierra, Intercom Fin or Ada?",
    a: "We believe AI customer experience isn't just a chat widget — it's a CRM. Every agent has access to the customer's full history, every channel, every tool, and every past decision. You get the conversation layer, the flow builder and the customer database in one place.",
  },
  {
    q: "Which LLMs can I use?",
    a: "All major providers — GPT (OpenAI), Claude (Anthropic) and Gemini (Google). You can mix models per-agent, pass BYO keys, or use our managed routing with automatic failover and cost-based routing.",
  },
  {
    q: "How do agents stay grounded and not hallucinate?",
    a: "Every answer is cited. Agents retrieve from your knowledge base, tools return structured data, and you can enforce a 'strict grounding' mode that refuses to answer outside your sources. Every chunk used is visible in the run trace.",
  },
  {
    q: "Can humans take over mid-conversation?",
    a: "Yes. Any conversation can be reassigned with a button — the human sees the full thread, tool calls made so far, and a suggested draft reply. You can resume AI handling any time.",
  },
  {
    q: "Do you have SSO, SOC 2 and data residency?",
    a: "Yes on all counts. SAML SSO, SCIM, SOC 2 Type II, GDPR, and region-locked storage in the EU, US or India. Enterprise plans include a DPA, BAA and dedicated VPC.",
  },
  {
    q: "What happens if an agent makes a mistake?",
    a: "You see it. Every run has a full trace — prompt, retrieved context, tool I/O, token spend. Roll back a prompt, fix a KB chunk, or escalate to human. Our changelog UI makes iteration transparent.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-28 md:py-40 border-t border-white/5"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="mb-14">
          <span className="text-[11px] font-mono tracking-[0.2em] uppercase text-[#3DDFB3] mb-5 block">
            ── FAQ
          </span>
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-white max-w-3xl">
            Answers, before
            <br />
            <span className="italic">you ask.</span>
          </h2>
        </div>

        <div className="border-t border-white/10">
          {faqs.map((f, i) => (
            <div
              key={i}
              className="border-b border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between text-left py-6 group"
                data-testid={`faq-toggle-${i}`}
              >
                <span className="font-serif text-[22px] md:text-[26px] text-white pr-6 leading-snug group-hover:text-white/90">
                  {f.q}
                </span>
                <span
                  className={`w-9 h-9 rounded-full border border-white/10 flex items-center justify-center flex-shrink-0 transition-colors ${
                    open === i
                      ? "bg-[#7C5CFF] border-[#7C5CFF]"
                      : "bg-white/[0.03]"
                  }`}
                >
                  {open === i ? (
                    <Minus className="w-4 h-4 text-white" />
                  ) : (
                    <Plus className="w-4 h-4 text-white/70" />
                  )}
                </span>
              </button>
              <div
                className={`grid transition-all duration-500 ease-out ${
                  open === i
                    ? "grid-rows-[1fr] opacity-100 pb-7"
                    : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="text-white/60 text-[16px] leading-relaxed max-w-3xl">
                    {f.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
